import React from 'react'

export const PaymentMethodContext = React.createContext({}) 